module.exports = __webpack_public_path__ + "static/media/img-7.c59c3d06.jpg";